// routes/_authenticated/fundos/index.tsx — entry point for `/fundos`.
// The page lives in `@/features/fundos`; this file is just router glue.
import { createFileRoute } from "@tanstack/react-router";

import { FundosPage } from "@/features/fundos";

export const Route = createFileRoute("/_authenticated/fundos/")({
  component: FundosPage,
});
